import module from './module.js'
/* Components */
import './components/nosoportado/component.js'
/* Routes */
import './routes/nosoportado.js'

export default module.name



// WEBPACK FOOTER //
// ./src/app/error/index.js